module.exports = __webpack_public_path__ + "img/valmiera-logo-icon.86e6ddc4.png";